import image1 from "./assets/customer-list/user-1.jpg";
import image2 from "./assets/customer-list/user-2.jpg";
import image3 from "./assets/customer-list/user-3.jpg";
import image4 from "./assets/customer-list/user-4.jpg";
import image5 from "./assets/customer-list/user-5.jpg";
import image6 from "./assets/customer-list/user-6.jpg";

const headerList = [
  { image: image1 },
  { image: image2 },
  { image: image3 },
  { image: image4 },
  { image: image5 },
  { image: image6 },
];
export default headerList;
